import { CheckCircleIcon, ClockIcon } from '@orn/shared-web/icons';
import * as React from 'react';

import type { MoveLineTone } from '../../lib/assistant/workItemMoveLine';

const TONE_ICONS: Record<MoveLineTone, typeof ClockIcon> = {
  waiting: ClockIcon,
  resolved: CheckCircleIcon,
};

interface IWorkItemMoveLineProps {
  /**
   * What the call left the work item as, as a finished sentence fragment —
   * "Waiting for response from Mom", "Marked Costco Visa as resolved".
   * Composed by `workItemMoveLine`; this component neither formats nor decides.
   */
  text: string;
  /** Picks the glyph: a clock while the work is still out, a check once it is done. */
  tone: MoveLineTone;
}

/**
 * The gray receipt under a tool-call report stating what that call left a
 * work item as: small gray text and a glyph, set at the same scale as the
 * report line above it so the cluster reads as one activity group.
 */
export default function WorkItemMoveLine({ text, tone }: IWorkItemMoveLineProps): React.ReactElement {
  const Icon = TONE_ICONS[tone];
  return (
    <div className="text-tertiary flex items-center gap-1 text-xs">
      <span>{text}</span>
      <Icon aria-hidden="true" className="size-3 shrink-0" />
    </div>
  );
}
